import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	doRecoverAccountWithTypeRequest,
	requestAccountRecoverWithTypeRequest,
} from "../../../store/modules/recoverPassword/actions";

import { maskPhone } from "../../../utils";
import ValidationPinCode from "../../../components/ValidationPinCode";

export default function ConfirmPinCodePhone(props) {
	const { recoverType, recoverData } = props;

	const dispatch = useDispatch();

	const { pinCodeFail, accountRecoverWithTypeResponse } = useSelector((state) => state.recoverPassword);

	const [tokenRecaptcha, setTokenRecaptcha] = useState({});
	const [recoverTime, setRecoverTime] = useState(30);
	const [codeResendControl, setCodeResendControl] = useState({
		isResendCode: false,
		last: recoverType,
	});
	const [typeCodeResend, setTypeCodeResend] = useState("o código");

	useEffect(() => {
		if (Object.keys(accountRecoverWithTypeResponse).length) {
			setRecoverTime(accountRecoverWithTypeResponse.seconds);
		}
	}, [accountRecoverWithTypeResponse]);

	useEffect(() => {
		if (Object.values(tokenRecaptcha).length && codeResendControl.isResendCode) {
			dispatch(
				requestAccountRecoverWithTypeRequest({
					documentType: recoverData.type.toUpperCase(),
					vlDocument: recoverData.document,
					recoveryInfo: recoverData.phone,
					recoveryInfoType: codeResendControl.last,
					operatingSystem: "WEB",
					header: tokenRecaptcha,
					isResendCode: true,
				})
			);

			setCodeResendControl((prev) => ({
				...prev,
				isResendCode: false,
			}));
		}
	}, [tokenRecaptcha, codeResendControl]);

	function resendPinCode(type) {
		setCodeResendControl({
			isResendCode: true,
			last: type,
		});

		setTypeCodeResend(`por ${recoverTypeFormatted(type)}`);
	}

	function tokenConfirmation(pin) {
		dispatch(
			doRecoverAccountWithTypeRequest({
				token: pin,
				type: "phone_mobile",
				value: recoverData.phone,
				vlDocument: recoverData.document,
			})
		);
	}

	function recoverTypeFormatted(type) {
		const action = {
			phone_mobile: () => "SMS",
			whatsapp: () => "WhatsApp",
		};

		return action[type]();
	}

	return (
		<ValidationPinCode
			title="Insira o código enviado para seu telefone"
			subtitle={`Enviado <span style="color: var(--brand-primary)">${typeCodeResend}</span> para o número ${maskPhone(recoverData.phone)}.`}
			error={pinCodeFail}
			messageError="Código inválido, revise e tente novamente"
			onSubmit={(pin) => tokenConfirmation(pin)}
			onResendCode={resendPinCode}
			resendType={recoverType}
			seconds={recoverTime}
			setTokenRecaptcha={setTokenRecaptcha}
		/>
	);
}
